import React from 'react';
import { createRoot } from 'react-dom/client';
import './modernized_app.css';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import App from './App';

const benignResizeObserverMessages = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];

function isBenignResizeObserverMessage(message) {
  return benignResizeObserverMessages.some(knownMessage =>
    String(message || '').includes(knownMessage)
  );
}

// CRA's dev overlay can surface benign ResizeObserver browser warnings as
// runtime errors. Filter only the known harmless messages so real errors
// still appear normally.
window.addEventListener('error', (event) => {
  if (isBenignResizeObserverMessage(event.message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

const previousWindowOnError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (isBenignResizeObserverMessage(message || error?.message)) {
    return true;
  }

  if (typeof previousWindowOnError === 'function') {
    return previousWindowOnError(message, source, lineno, colno, error);
  }

  return false;
};

window.addEventListener('unhandledrejection', (event) => {
  const message =
    typeof event.reason === 'string'
      ? event.reason
      : event.reason?.message;

  if (isBenignResizeObserverMessage(message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
